import React from 'react';

import { useSelector } from 'react-redux';
import cn from 'classnames';

import { selectProductSelectionContext } from '../../../store/selectors/productSelectionSelectors';
import { isMasterSelectionContext } from '../../../store/products/helpers/selectionContext';
import AggregatedMasterDetails from './AggregatedMasterDetails';
import AggregatedDraftDetails from './AggregatedDraftDetails';
import AggregatedPublishedDetails from './AggregatedPublishedDetails';
import tabStyles from '../ProductStateTabs/styles.module.scss';

const AggregatedProductDetails = () => {
  const context = useSelector(selectProductSelectionContext);
  const { recordState } = context || {};

  return (
    <div className={cn('InfoPanelBody', tabStyles.content)}>
      <Choose>
        <When condition={isMasterSelectionContext(context)}>
          <AggregatedMasterDetails />
        </When>
        <When condition={recordState === 'draft'}>
          <AggregatedDraftDetails />
        </When>
        <When condition={recordState === 'published'}>
          <AggregatedPublishedDetails />
        </When>
        <Otherwise>{null}</Otherwise>
      </Choose>
    </div>
  );
};

export default AggregatedProductDetails;
